var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0118 13.8367L3.30469 8.99229V10.8383L13.0118 15.6607L22.6992 10.9512V9.11237L13.0118 13.8367ZM3.30469 12.5895V14.4362L13.0118 19.2589L22.699 14.5493V12.7097L13.0118 17.4348L3.30469 12.5895ZM22.6922 7.22732L13.0118 2.74023L3.332 7.22732L13.0118 11.7148L22.6922 7.22732ZM13.0118 4.5644L18.7569 7.22732L13.0118 9.8906L7.26725 7.22732L13.0118 4.5644Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/Stack.56d09c91618abf8c5a2b749f958bdf15.svg";
export { ForwardRef as ReactComponent };